<template>
  <div>
    <div v-if="user !== null" class="article_user_box">
      <dl class="article_user_head">
        <dt><img :src="user.portrait" alt=""></dt>
        <dd>
          <a @click="userJump(user.user_id)" style="margin-right: 10px;">{{user.user_name}}</a>
          <el-popover
            v-if="user.is_enterprise === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台实名认证">
            <i class="my_icon_list shiming" slot="reference"></i>
          </el-popover>
          <el-popover
            v-if="user.is_authentication === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台播主认证">
            <i class="my_icon_list bozhu" slot="reference"></i>
          </el-popover>
          <el-popover
            v-if="user.is_lawyer === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台律师认证">
            <i class="my_icon_list lvshi" slot="reference"></i>
          </el-popover>
          <el-popover
            v-if="user.is_personal === 1"
            placement="top-start"
            trigger="hover"
            content="已通过平台企业认证">
            <i class="my_icon_list qiye" slot="reference"></i>
          </el-popover>
        </dd>
      </dl>
      <div class="article_user_container book_user_container">
        <p class="book_user_follow">
          {{user.fans_count}} 人关注
        </p>
        <p v-if="user.content !== null" class="book_user_content">
          简介：{{user.content}}
        </p>
        <p v-else class="book_user_content">
          作者暂无简介
        </p>
        <div v-if="currentUser===null" class="article_user_footer">
          <button v-if="user.is_follow === 0" class="my_follow_btn" @click="addFollow(user.user_id)">关注</button>
          <button v-if="user.is_follow === 1" class="glay_btn" @click="cancelFollow(user.user_id)">已关注</button>
          <button class="my_follow_btn" @click="dialogBtn">私信</button>
        </div>
        <div v-else-if="currentUser.id !== user.user_id" class="article_user_footer">
          <button v-if="user.is_follow === 0" class="my_follow_btn" @click="addFollow(user.user_id)">关注</button>
          <button v-if="user.is_follow === 1" class="glay_btn" @click="cancelFollow(user.user_id)">已关注</button>
          <button class="my_follow_btn" @click="dialogBtn">私信</button>
        </div>
      </div>
      <el-dialog
        class="detail_im_dialog"
        :title = "currentMes.name"
        :visible.sync="dialogIM"
        :width="dialogWidth"
        center
        :beforeClose="dialogCallback">
        <imright-view :info="currentMes"></imright-view>
      </el-dialog>
    </div>
    <div class="detail_recommend_box">
      <div v-if="userNewest.length > 0" class="detail_my_recommend_list">
        <div class="title_top_hr">
          <i></i>
          <p>
            <span>作者最新发布</span>
          </p>
          <el-divider></el-divider>
        </div>
        <div v-for="item in userNewest" :key="item.id" class="detail_my_recommend_item" @click="allJump(item.type, item.list_id, item.nav_id, item.is_doing)">
          {{item.title}}
        </div>
      </div>
      <div class="detail_recommend_list">
        <div class="title_top_hr">
          <i></i>
          <p>
            <span>相关推荐</span>
          </p>
          <el-divider></el-divider>
        </div>
        <div v-for="(item, index) in recommend" :key="item.id" class="detail_recommend_item">
          <i v-if="index === 0" class="first_label">{{index + 1}}</i>
          <i v-if="index === 1" class="two_label">{{index + 1}}</i>
          <i v-if="index === 2" class="three_label">{{index + 1}}</i>
          <i v-if="index > 2" class="glay_label">{{index + 1}}</i>
          <a @click="allJump(item.type, item.list_id, item.nav_id, item.is_doing)">{{item.title}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imRight from './imRight.vue'
export default {
  name: 'recommend',
  components: {
    imrightView: imRight
  },
  props: {
    list: {
      required: true
    }
  },
  data () {
    return {
      userNewest: [],
      recommend: [],
      user: null,
      currentUser: {}, // 当前登陆用户信息
      dialogWidth: '800px',
      dialogIM: false, // im弹窗是否显示
      currentMes: {
        id: '', // 用户id
        name: '', // 用户名称
        pic: '', // 用户名称
        list: [], // 用户聊天列表
        onOff: false, // 是否到聊天列表底部
        page: 0, // 默认分页
        type: 'dialog'
      } // 当前IM用户信息
    }
  },
  created () {
    console.log(this.list)
    this.currentUser = this.$store.state.user.info
    this.userNewest = this.list.user_newest
    this.recommend = this.list.Recommend
    this.user = this.list.user
  },
  methods: {
    allJump (type, rid, navId, isDoing) {
      this.mycommon.allJump(this, type, rid, navId, isDoing)
    },
    // 关注
    addFollow (id) {
      const vueThat = this
      vueThat.myApi.addFollow({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.user.fans_count += 1
          vueThat.user.is_follow = 1
          // vueThat.$alert('关注成功', '温馨提示', {
          //   type: 'success',
          //   iconClass: 'iconfont icon-icon_richeng_btn_pass',
          //   confirmButtonText: '确定',
          //   showClose: false,
          //   callback: action => {
          //     vueThat.user.fans_count += 1
          //     vueThat.user.is_follow = 1
          //   }
          // })
        }
      })
    },
    // 取消关注
    cancelFollow (id) {
      const vueThat = this
      vueThat.$confirm('是否取消关注?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.user.fans_count -= 1
            vueThat.user.is_follow = 0
          }
        })
      }).catch(() => {})
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 私信按钮
    dialogBtn () {
      const vueThat = this
      if (vueThat.currentUser !== null) {
        vueThat.dialogIM = true
        vueThat.currentMes.id = vueThat.user.user_id
        vueThat.currentMes.name = vueThat.user.user_name
        vueThat.currentMes.pic = vueThat.user.portrait
        const onMessageReceived = async function (event) {
          const message = event.data[0]
          if (message.from === vueThat.currentMes.id + '') {
            vueThat.currentMes.list.push(message)
            vueThat.setMessageRead()
            vueThat.scrollToBottom()
          }
        }
        vueThat.webIM.on(vueThat.webIM.EVENT.MESSAGE_RECEIVED, onMessageReceived)
        vueThat.onLogin() // 登录IM
        vueThat.onSdkReady()
      } else {
        vueThat.$alert('您还未登录账号！', '温馨提示', {
          type: 'error',
          confirmButtonText: '去登录',
          showClose: false,
          callback: () => {
            vueThat.$router.push({ name: 'Login' })
          }
        })
      }
    },
    // 登陆IM
    onLogin () {
      const vueThat = this
      const promise = vueThat.webIM.login({ userID: vueThat.currentUser.id + '', userSig: vueThat.currentUser.sig })
      promise.then(function (res) {
        if (res.data.repeatLogin === true) {
          // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
          vueThat.webIM.getMessageList({ conversationID: 'C2C' + vueThat.currentMes.id, count: 15 }).then(function (imResponse) {
            vueThat.currentMes.list.push(...imResponse.data.messageList) // 消息列表。
            vueThat.currentMes.page = imResponse.data.nextReqMessageID // 用于续拉，分页续拉时需传入该字段。
            vueThat.currentMes.onOff = imResponse.data.nextReqMessageID // 表示是否已经拉完所有消息。
            vueThat.scrollToBottom()
            vueThat.setMessageRead()
            vueThat.editReadMsg()
          })
        }
      }).catch(function (imError) {
        console.log(imError)
        vueThat.dialogIM = false
        vueThat.$alert('即时通讯登录错误，请重试！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            vueThat.$router.go(-1)
          }
        })
      })
    },
    // IM登陆为 ready 状态时触发
    onSdkReady () {
      const vueThat = this
      const onSdkReady = function (event) {
        // 打开某个会话时，第一次拉取消息列表
        vueThat.webIM.getMessageList({ conversationID: 'C2C' + vueThat.currentMes.id, count: 15 }).then(function (imResponse) {
          vueThat.currentMes.list.push(...imResponse.data.messageList) // 消息列表。
          vueThat.currentMes.page = imResponse.data.nextReqMessageID // 用于续拉，分页续拉时需传入该字段。
          vueThat.currentMes.onOff = imResponse.data.nextReqMessageID // 表示是否已经拉完所有消息。
          vueThat.scrollToBottom()
          vueThat.setMessageRead()
          vueThat.editReadMsg()
        })
      }
      vueThat.webIM.on(vueThat.webIM.EVENT.SDK_READY, onSdkReady)
    },
    // 腾讯云IM已读消息上报
    setMessageRead () {
      const vueThat = this
      // 将某会话下所有未读消息已读上报
      vueThat.webIM.setMessageRead({ conversationID: 'C2C' + vueThat.currentMes.id }).then(function (imResponse) {
      }).catch(function (imError) {
        // 已读上报失败
        console.warn('setMessageRead error:', imError)
      })
    },
    // 平台已读消息上报
    editReadMsg () {
      const vueThat = this
      vueThat.myApi.editReadMsg({ user_id: vueThat.currentMes.id })
    },
    // 始终在对话框最底部
    scrollToBottom () {
      this.$nextTick(() => {
        const div = document.getElementById('messageView')
        div.scrollTop = div.scrollHeight
      })
    },
    // im弹窗关闭后的回调
    dialogCallback () {
      this.editReadMsg()
      this.dialogIM = false
    }
  }
}
</script>

<style>
</style>
